//search bar below the menu bar
// Search field icon toggle functionality
let searchToggleInitialized = false;
let clickOutsideHandler = null;

function initSearchIconToggle() {
  const searchInput = document.querySelector('input[name="q"]');
  if (!searchInput || searchInput.dataset.searchToggleAdded) return;

  const searchContainer =
    searchInput.closest(".\\#predictive-search-input") ||
    searchInput.closest("predictive-search-input");
  if (!searchContainer) return;

  // Find search icon and close icon
  const searchIcon =
    searchContainer.querySelector(
      '[class*="search-popup-icon"]:not([class*="close"])'
    ) || searchContainer.querySelector(".\\#search-popup-icon");
  const closeIcon =
    searchContainer.querySelector('[class*="search-popup-close"]') ||
    searchContainer.querySelector("modal-close") ||
    searchContainer.querySelector(".\\#search-popup-close");
  const resultsContainer = searchContainer.querySelector("[data-results]");

  if (!searchIcon || !closeIcon) return;

  // Mark as initialized to avoid duplicate listeners
  searchInput.dataset.searchToggleAdded = "true";

  // Function to update icon visibility
  function updateIcons() {
    const hasValue = searchInput.value.trim().length > 0;
    // searchIcon.style.display = hasValue ? "none" : "block";
    closeIcon.style.display = hasValue ? "block" : "none";
  }

  // Function to clear search
  function clearSearch() {
    searchInput.value = "";
    updateIcons();

    // Clear predictive search results
    if (resultsContainer) {
      resultsContainer.innerHTML = "";
    }

    // Also clear any predictive search section
    const predictiveSearchSection = document.querySelector(
      "#shopify-section-predictive-search"
    );
    if (predictiveSearchSection) {
      predictiveSearchSection.remove();
    }
  }

  // Handle input events
  searchInput.addEventListener("input", () => {
    updateIcons();
  });

  // Handle close icon click
  closeIcon.addEventListener("click", (e) => {
    if (searchInput.value.trim().length > 0) {
      e.preventDefault();
      e.stopPropagation();
      clearSearch();
      searchInput.focus();
    }
  });

  // Handle click outside (only add once)
  if (!searchToggleInitialized) {
    searchToggleInitialized = true;
    clickOutsideHandler = (e) => {
      const searchInputs = document.querySelectorAll('input[name="q"]');
      searchInputs.forEach((input) => {
        if (input.value.trim().length > 0) {
          const container =
            input.closest(".\\#predictive-search-input") ||
            input.closest("predictive-search-input");
          if (!container) return;

          const results = container.querySelector("[data-results]");
          const isInside =
            container.contains(e.target) ||
            (results && results.contains(e.target)) ||
            (document.querySelector("#shopify-section-predictive-search") &&
              document
                .querySelector("#shopify-section-predictive-search")
                .contains(e.target));

          if (!isInside) {
            input.value = "";
            const searchIcon =
              container.querySelector(
                '[class*="search-popup-icon"]:not([class*="close"])'
              ) || container.querySelector(".\\#search-popup-icon");
            const closeIcon =
              container.querySelector('[class*="search-popup-close"]') ||
              container.querySelector("modal-close") ||
              container.querySelector(".\\#search-popup-close");

            if (searchIcon) searchIcon.style.display = "block";
            if (closeIcon) closeIcon.style.display = "none";

            if (results) results.innerHTML = "";
            const predictiveSearchSection = document.querySelector(
              "#shopify-section-predictive-search"
            );
            if (predictiveSearchSection) {
              predictiveSearchSection.remove();
            }
          }
        }
      });
    };
    document.addEventListener("click", clickOutsideHandler);
  }

  // Initialize icon visibility
  updateIcons();
}


function bindSearchRedirectHandlers() {
  const selectors = [
    '.\\#main-header-inner .\\#search-popup-icon',
    '#shopify-section-predictive-search .\\#search-popup-icon',
    '.\\#main-header-inner [class*="search-popup-icon"]:not([class*="close"])',
    '#shopify-section-predictive-search [class*="search-popup-icon"]:not([class*="close"])'
  ];
  const icons = document.querySelectorAll(selectors.join(", "));
  icons.forEach((icon) => {
    if (icon.dataset.redirectBound === "true") return;
    icon.dataset.redirectBound = "true";
    icon.addEventListener("click", (e) => {
      console.log("Search icon clicked for redirect", e.target);
      e.preventDefault();
      e.stopPropagation();

      const container = icon.closest('.\\#predictive-search-input') ||
        icon.closest('#shopify-section-predictive-search') ||
        document.querySelector('.\\#main-header-inner');

      let input = container && container.querySelector('input[name="q"]');
      if (!input) {
        input = document.querySelector('.\\#main-header-inner .\\#search-popup-input') ||
          document.querySelector('#shopify-section-predictive-search input[name="q"]');
      }
      if (!input) return;

      const query = input.value.trim().toLowerCase().replace(/\\s+/g, '+');
      console.log("Redirecting to search?q=" + query);
      if (query) {
        window.location.href = `/search?q=${query}`;
      }
    });
  });
}

clickOutsideHandler = (e) => {
  const predictiveSearch = document.querySelector(
    "#shopify-section-predictive-search .\\#predictive-search"
  );
  if (!predictiveSearch) return;

  // Ignore clicks on header search controls inside the modal/header
  const clickedHeaderSearchControl = !!(
    e.target.closest('.\\#main-header-inner .\\#search-popup-icon') ||
    e.target.closest('.\\#main-header-inner .\\#search-popup-input') ||
    e.target.closest('.\\#main-header-inner .\\#search-popup-close') ||
    e.target.closest('#shopify-section-predictive-search .\\#search-popup-icon') ||
    e.target.closest('#shopify-section-predictive-search .\\#search-popup-input') ||
    e.target.closest('#shopify-section-predictive-search .\\#search-popup-close')
  );
  if (clickedHeaderSearchControl) {
    console.log("Ignored outside-click: header search control interaction", e.target);
    return;
  }

  // Check if click happened inside predictive search
  const isInside = predictiveSearch.contains(e.target);

  if (!isInside) {
    // Find modal close button and trigger click
    const modalClose = document.querySelector(
      ".\\#main-header-inner modal-close"
    );
    if (modalClose) {
      modalClose.click();
      console.log("Clicked modal close due to outside click");
    } else {
      console.log("modal-close not found inside #main-header-inner");
    }
  }
};

document.addEventListener("DOMContentLoaded", () => {
  initSearchIconToggle();
  bindSearchRedirectHandlers();

  // Also listen for dynamic content (like when modal opens)
  const observer = new MutationObserver(() => {
    const searchInput = document.querySelector('input[name="q"]');
    const searchIcon = document.querySelector(
      '[class*="search-popup-icon"]:not([class*="close"])'
    );
    if (searchInput && searchIcon && !searchIcon.dataset.listenerAdded) {
      initSearchIconToggle();
      bindSearchRedirectHandlers();
      searchIcon.dataset.listenerAdded = "true";
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});

document.addEventListener("click", clickOutsideHandler);

// collection quick add to cart winner test
/* Product Card Model - Quick View Button */
document.addEventListener("DOMContentLoaded", function () {
  const quickViewButtons = document.querySelectorAll(".c-quick-view-btn");

  quickViewButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const handle = this.getAttribute("data-handle");
      const productModal = document.querySelector(`.c-product-model[data-handle="${handle}"]`);

      if (productModal) {
        // Add an "active" class to show the modal
        productModal.classList.add("active");

        // Optional: lock body scroll when modal is open
        document.body.classList.add("modal-open");
      }
    });
  });

  // Close modal when clicking outside or pressing ESC
  document.addEventListener("click", function (e) {
    const activeModal = document.querySelector(".c-product-model.active");
    if (activeModal && e.target === activeModal) {
      activeModal.classList.remove("active");
      document.body.classList.remove("modal-open");
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      const activeModal = document.querySelector(".c-product-model.active");
      if (activeModal) {
        activeModal.classList.remove("active");
        document.body.classList.remove("modal-open");
      }
    }
  });
});

let cLastVariantThumbnailId = null;

// Function to slide to thumbnail based on variant ID
function slideToVariantThumbnail(variantId, context = document) {
  if (!variantId) return;
  const variantKey = String(variantId);

  // Prevent re-triggering the same thumbnail in a loop
  if (variantKey === cLastVariantThumbnailId) return;

  // Find the closest product section context (modal or page)
  const productSection = context.closest?.('.c-product-modal, .product-section') ||
    context.querySelector?.('.c-product-modal, .product-section') ||
    document.querySelector('.c-product-modal, .product-section');

  if (!productSection) return;

  // Find all thumbnail elements within the same context
  const thumbs = productSection.querySelectorAll('.\\#slideshow-thumbnails-item');

  // Loop through thumbnails to find a match by data-variant-ids
  // Note: data-variant-ids might contain multiple IDs, so we check if our variant ID is included
  for (let i = 0; i < thumbs.length; i++) {
    const thumb = thumbs[i];
    const variantIds = thumb.dataset.variantIds || thumb.getAttribute('data-variant-ids');

    if (variantIds) {
      // Check if the variant ID is in the variant IDs string (could be comma or space separated)
      const variantIdsArray = variantIds.split(/[,\s]+/).map(id => id.trim());
      if (variantIdsArray.includes(String(variantId))) {
        cLastVariantThumbnailId = variantKey;
        requestAnimationFrame(() => {
          thumb.click(); // trigger Swiper's native behavior to slide to that section
          // Allow the same variant to be selected again after the current frame
          setTimeout(() => {
            if (cLastVariantThumbnailId === variantKey) {
              cLastVariantThumbnailId = null;
            }
          }, 250);
        });
        return true; // found and clicked
      }
    }
  }
  return false; // not found
}

// Function to initialize thumbnail click handler
function initThumbnailClickHandler(context = document) {
  context.querySelectorAll('.\\#product-option-picker-body .\\#form-field').forEach((label) => {
    // Skip if already has listener
    if (label.dataset.thumbnailListener) return;
    label.dataset.thumbnailListener = 'true';

    label.addEventListener('click', () => {
      // Find the closest product section context (modal or page)
      const productSection = label.closest('.c-product-modal, .product-section');
      if (!productSection) return;

      // Wait a bit for the variant ID to be updated in the input after the click
      // The variant change handler updates the input name="id" with the new variant ID
      setTimeout(() => {
        // Get the variant ID from the input name="id" (with data-variant-id-input attribute)
        // This input is updated when variant changes
        const variantIdInput = productSection.querySelector('[name="id"][data-variant-id-input]') ||
          productSection.querySelector('[name="id"]') ||
          label.closest('product-form')?.querySelector('[name="id"][data-variant-id-input]') ||
          label.closest('product-form')?.querySelector('[name="id"]');

        if (!variantIdInput) return;

        const variantId = variantIdInput.value?.trim();
        if (!variantId) return;

        // Use the helper function to slide to the thumbnail
        slideToVariantThumbnail(variantId, productSection);
      }, 100); // Small delay to ensure variant ID is updated
    });
  });
}

// Initialize on page load
initThumbnailClickHandler();

// Listen for variant changes to slide to the corresponding thumbnail
document.addEventListener('variantChange', (e) => {
  // Wait a bit for the variant ID input to be updated
  setTimeout(() => {
    const variant = e.detail?.variant;
    if (variant?.id) {
      // Try to find the product section from the event target
      const productSection = e.target?.closest?.('.c-product-modal, .product-section') ||
        document.querySelector('.c-product-modal, .product-section');
      slideToVariantThumbnail(String(variant.id), productSection || document);
    }
  }, 50);
});

// Function to update add to cart button price in modal only
function updateModalButtonPrice() {
  // Only update in modal context
  const modal = document.querySelector('modal-popup[opened]') ||
    document.querySelector('.c-product-modal') ||
    document.querySelector('modal-popup');

  if (!modal) return;

  // Find the add to cart button in the modal
  const addButton = modal.querySelector('[data-add-button]');
  if (!addButton) return;

  // Find the product-price element in the modal
  // Check multiple locations: inside button, near button, or in modal
  const productPrice = addButton.closest('.\\#button-inner')?.querySelector('product-price') ||
    addButton.closest('product-form')?.querySelector('product-price') ||
    modal.querySelector('product-price');

  if (!productPrice) return;

  // Get the price text from product-price element
  // Try to get the actual price value - look for price-value span first
  let priceText = productPrice.querySelector('.\\#price-value')?.textContent?.trim() ||
    productPrice.querySelector('[class*="price-value"]')?.textContent?.trim();

  // If not found in span, get from text content
  if (!priceText) {
    priceText = productPrice.textContent?.trim();
    // If price contains multiple values (like compare at price), get the first/main price
    if (priceText) {
      // Split by common separators and get the first price-like value
      const priceMatch = priceText.match(/[\$£€¥]\s*[\d,]+\.?\d*/);
      if (priceMatch) {
        priceText = priceMatch[0];
      } else {
        // Fallback: get first non-empty line or first word
        priceText = priceText.split(/\s+/).find(part => part && part.length > 0) || priceText;
      }
    }
  }

  if (!priceText) return;

  // Find the button text element
  const buttonText = addButton.querySelector('.\\#button-text');
  if (!buttonText) return;

  // Get the add to cart text (either from i18n or existing text)
  const currentText = buttonText.textContent || '';
  const addToCartText = window.theme?.i18n?.addToCart ||
    (currentText.includes(' - ') ? currentText.split(' - ')[0] : currentText) ||
    'ADD TO CART';

  // Update button text with price
  buttonText.textContent = `${addToCartText} - ${priceText}`;
}

// Re-initialize when modal opens
document.addEventListener('popupOpened', () => {
  // Wait a bit for modal content to be fully injected
  setTimeout(() => {
    const modalContent = document.querySelector('.\\#modal-popup-content');
    if (modalContent) {
      initThumbnailClickHandler(modalContent);
    }
    // Update button price when modal opens
    updateModalButtonPrice();
  }, 100);
});

// Also use event delegation for dynamically added content
document.addEventListener('click', (e) => {
  const label = e.target.closest('.\\#product-option-picker-body .\\#form-field');
  if (!label || label.dataset.thumbnailListener) return;

  // Initialize handler for this newly added element
  initThumbnailClickHandler(label.closest('.c-product-modal, .product-section') || document);
});

// Listen for cart updates to update button price in modal
document.addEventListener('updateCart', () => {
  // Wait a bit for the cart to update and price to be available
  setTimeout(() => {
    updateModalButtonPrice();
  }, 100);
});

// Also update when variant changes in modal (price might change)
document.addEventListener('variantChange', (e) => {
  // Check if we're in a modal
  const isInModal = e.target?.closest('modal-popup') !== null ||
    e.target?.closest('.c-product-modal') !== null;

  if (isInModal) {
    // Wait a bit for price to update
    setTimeout(() => {
      updateModalButtonPrice();
    }, 100);
  }
});
// collection quick add to cart winner test

// Cart Add-Ons: Move to scrollable area on mobile
(function() {
  'use strict';

  const MOBILE_BREAKPOINT = 640;

  function moveAddonsForMobile() {
    if (window.innerWidth > MOBILE_BREAKPOINT) return;

    const addonsSection = document.querySelector('.cart-bottom-meta .cart-addons-section');
    const cartItemsWrapper = document.querySelector('.cart-items-wrapper');
    if (!addonsSection || !cartItemsWrapper) return;

    // Move addons to end of cart-items-wrapper
    cartItemsWrapper.appendChild(addonsSection);
  }

  document.addEventListener('DOMContentLoaded', moveAddonsForMobile);
  document.addEventListener('popupOpened', () => setTimeout(moveAddonsForMobile, 100));
  document.addEventListener('cartChange', () => setTimeout(moveAddonsForMobile, 300));
  document.addEventListener('addonsUpdated', () => setTimeout(moveAddonsForMobile, 150));
})();

// Cart Add-Ons Functionality
(function() {
  'use strict';

  class CartAddonsManager {
    constructor() {
      this.swiper = null;
      this.swiperLoaded = false;
      this.swiperLoading = false;
      this._listenersAttached = false;
    }

    showLoading() {
      const loading = document.querySelector('.cart-addons-loading');
      if (loading) loading.classList.add('active');
    }

    hideLoading() {
      const loading = document.querySelector('.cart-addons-loading');
      if (loading) loading.classList.remove('active');
    }

    updateHeaderVisibility() {
      const container = document.querySelector('[data-cart-addons]');
      const header = document.querySelector('.cart-addons-header');
      if (!container || !header) return;

      // Check if there are any slides in the wrapper
      const wrapper = container.querySelector('.swiper-wrapper');
      if (!wrapper) return;

      const slides = wrapper.querySelectorAll('.swiper-slide');
      
      // Hide header if no slides exist (all add-ons are in cart)
      if (slides.length === 0) {
        header.style.display = 'none';
      } else {
        header.style.display = '';
      }
    }

    async preloadSwiper() {
      if (this.swiperLoaded || window.Swiper || this.swiperLoading) return;
      
      this.swiperLoading = true;
      try {
        if (!window.theme?.modules?.utils) return;
        const { loadScript, loadStyle } = await import(window.theme.modules.utils);
        
        // Load CSS and JS in parallel for faster loading
        const loadPromises = [];
        if (window.theme.styles?.Swiper) {
          loadPromises.push(loadStyle(window.theme.styles.Swiper));
        }
        if (window.theme.scripts?.Swiper) {
          loadPromises.push(loadScript(window.theme.scripts.Swiper, 'swiper'));
        }
        
        await Promise.all(loadPromises);
        
        // Wait for Swiper to be available
        let attempts = 0;
        while (!window.Swiper && attempts < 20) {
          await new Promise(resolve => setTimeout(resolve, 50));
          attempts++;
        }
        
        if (window.Swiper) {
          this.swiperLoaded = true;
        }
      } catch (error) {
        console.error('Error preloading Swiper:', error);
      } finally {
        this.swiperLoading = false;
      }
    }

    async init() {
      const container = document.querySelector('[data-cart-addons]');
      if (!container) return;

      const slides = container.querySelectorAll('.swiper-slide');
      if (slides.length === 0) return;

      const prevBtn = document.querySelector('.cart-addons-prev');
      const nextBtn = document.querySelector('.cart-addons-next');
      if (!prevBtn || !nextBtn) return;

      // Destroy old Swiper if exists
      if (this.swiper) {
        try {
          this.swiper.destroy(true, true);
        } catch (e) {}
        this.swiper = null;
      }

      // Ensure Swiper is loaded
      if (!this.swiperLoaded && !window.Swiper) {
        await this.preloadSwiper();
      }
      
      if (!window.Swiper) return;

      // Initialize Swiper
      try {
        this.swiper = new window.Swiper(container, {
          slidesPerView: 1.25,
          spaceBetween: 5,
          navigation: { nextEl: nextBtn, prevEl: prevBtn },
          touchEventsTarget: 'container',
          allowTouchMove: true,
          grabCursor: true,
          noSwiping: true,
          noSwipingSelector: '.cart-addon-btn, .cart-addon-variant-select',
          breakpoints: {
            992: { slidesPerView: 1.4, spaceBetween: 5, allowTouchMove: false, grabCursor: false }
          }
        });
        
        // Update header visibility after Swiper initialization
        this.updateHeaderVisibility();
      } catch (error) {
        console.error('Error initializing Swiper:', error);
      }
    }

    attachEventListeners() {
      if (this._listenersAttached) return;
      this._listenersAttached = true;

      // Event delegation for add to cart
      document.addEventListener('click', (e) => {
        const button = e.target.closest('.cart-addon-btn');
        if (button && button.closest('[data-cart-addons]')) {
          e.stopPropagation();
          this.handleAddToCart(button);
        }
      });

      // Event delegation for variant select
      document.addEventListener('change', (e) => {
        if (e.target.classList.contains('cart-addon-variant-select')) {
          this.handleVariantChange(e);
        }
      });
    }

    handleVariantChange(e) {
      const select = e.target;
      const selectedOption = select.options[select.selectedIndex];
      const variantId = selectedOption.value;
      const price = selectedOption.dataset.price;
      const imageUrl = selectedOption.dataset.image;

      const card = select.closest('.cart-addon-card');
      const priceElement = card.querySelector('.cart-addon-price');
      const addButton = card.querySelector('.cart-addon-btn');
      const imageElement = card.querySelector('.cart-addon-image img');

      if (priceElement && price) {
        const formattedPrice = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD'
        }).format(price / 100);
        priceElement.textContent = formattedPrice;
      }

      if (addButton) {
        addButton.dataset.variantId = variantId;
      }

      if (imageElement && imageUrl) {
        imageElement.src = imageUrl;
        imageElement.alt = selectedOption.textContent.trim();
      }
    }

    async handleAddToCart(button) {
      const variantId = button.dataset.variantId;
      if (!variantId || !window.routes?.cart_add_url) return;

      button.classList.add('adding');
      button.disabled = true;
      button.textContent = 'ADDING...';
      this.showLoading();

      try {
        const response = await fetch(window.routes.cart_add_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
        });

        const data = await response.json();
        if (data.status === 422) throw new Error(data.description || 'Failed to add to cart');

        const cartElement = document.querySelector('main-cart');
        if (cartElement?.update) {
          cartElement.update(() => {
            button.classList.remove('adding');
            button.disabled = false;
            button.textContent = 'ADDED!';
            setTimeout(() => {
              button.textContent = 'ADD +';
              this.hideLoading();
            }, 2000);
          });
        } else {
          this.hideLoading();
          window.location.reload();
        }
      } catch (error) {
        console.error('Error adding to cart:', error);
        button.classList.remove('adding');
        button.disabled = false;
        button.textContent = 'ERROR';
        this.hideLoading();
        setTimeout(() => button.textContent = 'ADD +', 2000);
      }
    }
  }

  const cartAddonsManager = new CartAddonsManager();

  let _initCartAddonsTimer = null;
  function initCartAddonsDebounced() {
    if (_initCartAddonsTimer) clearTimeout(_initCartAddonsTimer);
    _initCartAddonsTimer = setTimeout(() => {
      _initCartAddonsTimer = null;
      const container = document.querySelector('[data-cart-addons]');
      if (container) {
        cartAddonsManager.init();
        cartAddonsManager.attachEventListeners();
        cartAddonsManager.updateHeaderVisibility();
      } else {
        setTimeout(() => {
          const retryContainer = document.querySelector('[data-cart-addons]');
          if (retryContainer) {
            cartAddonsManager.init();
            cartAddonsManager.attachEventListeners();
            cartAddonsManager.updateHeaderVisibility();
          }
        }, 50);
      }
    }, 200);
  }

  // Preload Swiper early for faster initialization
  function preloadSwiperEarly() {
    // Preload when page loads
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        cartAddonsManager.preloadSwiper();
      });
    } else {
      cartAddonsManager.preloadSwiper();
    }
  }


  // Preload Swiper immediately
  preloadSwiperEarly();

  // Preload Swiper when user hovers over or clicks cart icon
  function setupCartIconPreload() {
    const cartTriggers = document.querySelectorAll('modal-trigger[target="CART"], modal-trigger[target="CART"] a, modal-trigger[target="CART"] button');
    cartTriggers.forEach(trigger => {
      // Preload on hover
      trigger.addEventListener('mouseenter', () => {
        cartAddonsManager.preloadSwiper();
      }, { once: true });
      
      // Preload on click
      trigger.addEventListener('click', () => {
        cartAddonsManager.preloadSwiper();
      }, { once: true });
    });
  }

  // Setup cart icon preload
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupCartIconPreload);
  } else {
    setupCartIconPreload();
  }

  // Watch for dynamically added cart triggers
  const observer = new MutationObserver(() => {
    setupCartIconPreload();
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // Initialize on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartAddonsDebounced);
  } else {
    initCartAddonsDebounced();
  }

  // Initialize immediately when cart drawer opens
  document.addEventListener('popupOpened', () => {
    // Check if it's the cart drawer
    const cartSection = document.querySelector('[data-main-cart]');
    if (cartSection) {
      // Preload Swiper if not already loaded
      cartAddonsManager.preloadSwiper();
      // Initialize immediately
      setTimeout(() => {
        initCartAddonsDebounced();
      }, 50);
    }
  });

  // Reinitialize after cart updates (including when items are removed)
  document.addEventListener('cartChange', () => {
    cartAddonsManager.showLoading();
    // Add-ons section is already updated by cart.js, just reinitialize Swiper
    // Use a slightly longer delay to ensure DOM is fully updated
    setTimeout(() => {
      initCartAddonsDebounced();
      cartAddonsManager.updateHeaderVisibility();
      cartAddonsManager.hideLoading();
    }, 250);
  });

  // Also listen for explicit addons update event
  document.addEventListener('addonsUpdated', () => {
    cartAddonsManager.showLoading();
    setTimeout(() => {
      initCartAddonsDebounced();
      cartAddonsManager.updateHeaderVisibility();
      cartAddonsManager.hideLoading();
    }, 100);
  });
})();

// V_MJA_PDP_18 | Free Cleaning Guide — Winner: Var A (always on)
window.hasCleaningGuide = true;
document.body.classList.add('c-freeCleaningGuide-test');
fetch('/cart/update.js', {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify({ attributes: { 'has_cleaning_guide': 'true' } })
});

// V_MJA_PDP_18 | Free Cleaning Guide - Auto Add/Remove from Cart
(function() {
  'use strict';

  let c_guideConfig = null;
  let c_syncInProgress = false;

  function getCleaningGuideConfig() {
    if (c_guideConfig) return c_guideConfig;
    const el = document.querySelector('[data-c-cleaning-guide-config]');
    if (!el) return null;
    try {
      c_guideConfig = JSON.parse(el.textContent);
      return c_guideConfig;
    } catch (e) {
      return null;
    }
  }

  async function syncCleaningGuideInCart() {
    if (!window.hasCleaningGuide) return;
    if (c_syncInProgress) return;

    const config = getCleaningGuideConfig();
    if (!config || !config.variantId) return;

    c_syncInProgress = true;
    const guideVariantId = parseInt(config.variantId);
    const qualifyingProductIds = (config.qualifyingProductIds || []).map(Number);

    try {
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      const cart = await res.json();

      const guideLineItem = cart.items.find(item => item.variant_id === guideVariantId);
      const hasQualifyingProduct = cart.items.some(item => {
        if (item.variant_id === guideVariantId) return false;
        if (item.properties?._bundle_id) return true; 
        return qualifyingProductIds.includes(item.product_id);
      });

      let cartChanged = false;

      if (hasQualifyingProduct && !guideLineItem) {
        // Add the guide variant (quantity 1)
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: guideVariantId, quantity: 1 }] })
        });
        cartChanged = true;
      } else if (hasQualifyingProduct && guideLineItem && guideLineItem.quantity > 1) {
        // Cap quantity to 1 if somehow more were added
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: guideLineItem.key, quantity: 1 })
        });
        cartChanged = true;
      } else if (!hasQualifyingProduct && guideLineItem) {
        // Remove the guide variant entirely
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: guideLineItem.key, quantity: 0 })
        });
        cartChanged = true;
      }

      // Refresh cart UI if we made changes
      if (cartChanged) {
        const mainCart = document.querySelector('main-cart');
        if (mainCart?.update) {
          mainCart.update(() => {});
        }
        // Notify cart counter and other listeners to re-fetch cart
        document.dispatchEvent(new CustomEvent('updateCart', {
          bubbles: true,
          composed: true,
          detail: {}
        }));
      }
    } catch (e) {
      console.error('Cleaning guide cart sync error:', e);
    } finally {
      c_syncInProgress = false;
    }
  }

  // Run on initial cart load (after Intelligems is ready so we don't race other test logic)
  window.addEventListener('ig:ready', () => {
    syncCleaningGuideInCart();
  });

  // Re-sync when cart changes
  document.addEventListener('cartChange', () => {
    setTimeout(syncCleaningGuideInCart, 300);
  });

  document.addEventListener('updateCart', () => {
    setTimeout(syncCleaningGuideInCart, 300);
  });
})();

// estimate delivery date winner test
document.body.classList.add("c-delivery-date-var-a");
function initDeliveryDate() {
  const variantA = document.getElementById('c-delivery-date-variant-a');

  // Winner declared: Var A only
  if (!variantA) return;

  const today = new Date();

  // Format date as "Day, Month Date" (e.g., "Thursday, Oct 24")
  function formatDateRange(date) {
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const dayName = days[date.getDay()];
    const month = months[date.getMonth()];
    const day = date.getDate();
    return `${dayName}, ${month} ${day}`;
  }

  // Calculate dates
  const startDate = new Date(today);
  startDate.setDate(today.getDate() + 2);

  const endDate = new Date(today);
  endDate.setDate(today.getDate() + 4);

  // Update Variation A (Arrives between dates)
  const startSpan = variantA.querySelector('.c-delivery-date-start');
  const endSpan = variantA.querySelector('.c-delivery-date-end');
  if (startSpan) startSpan.textContent = formatDateRange(startDate);
  if (endSpan) endSpan.textContent = formatDateRange(endDate);
}

// Initialize delivery date on page load
document.addEventListener('DOMContentLoaded', () => {
  initDeliveryDate();
});

// Re-initialize when cart drawer opens
document.addEventListener('popupOpened', () => {
  setTimeout(() => {
    initDeliveryDate();
    // Popup handler uses event delegation, so no need to re-init
  }, 100);
});

// Also listen for cart updates
document.addEventListener('updateCart', () => {
  setTimeout(() => {
    initDeliveryDate();
    // Popup handler uses event delegation, so no need to re-init
  }, 100);
});

// V_MJA_CART_01 | Delivery Date Popup Handler
document.addEventListener('click', function (e) {
  const popup = document.getElementById('c-delivery-date-popup');
  if (!popup) return;

  // Open popup when icon button or SVG inside is clicked
  const iconBtn = e.target.closest('.c-delivery-date-icon-btn');
  const iconSvg = e.target.closest('.c-delivery-date-icon-a');
  if (iconBtn || iconSvg) {
    e.preventDefault();
    e.stopPropagation();
    popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    return;
  }

  // Close popup when close button or overlay is clicked
  if (e.target.closest('.c-delivery-date-popup-close') || e.target.classList.contains('c-delivery-date-popup-overlay')) {
    e.preventDefault();
    popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
});

// V_MJA_CART_01 | Delivery Date Hover Trigger
document.addEventListener('click', function (e) {
  const popup = document.getElementById('c-delivery-date-popup');
  if (!popup || popup.getAttribute('aria-hidden') === 'false') return;

  const hoverTarget = e.target.closest('.c-delivery-date-text-a');
  if (!hoverTarget) return;

  popup.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
});

// Close popup on ESC key
document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape') {
    const popup = document.getElementById('c-delivery-date-popup');
    if (popup && popup.getAttribute('aria-hidden') === 'false') {
      popup.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  }
});
// estimate delivery date winner test


// V_MJA_PDP_23 | Reassurance Policy Modal
(function () {
  let modalMoved = false;

  function getModal() {
    const modal = document.querySelector('.c-reassurance-policy-pdp__modal');
    if (modal && !modalMoved) {
      document.body.appendChild(modal);
      modalMoved = true;
    }
    return modal;
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('.c-reassurance-policy-pdp__info-btn')) {
      e.preventDefault();
      const modal = getModal();
      if (!modal) return;
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      return;
    }

    const modal = document.querySelector('.c-reassurance-policy-pdp__modal');
    if (!modal) return;

    if (e.target.closest('.c-reassurance-policy-pdp__modal-close') || e.target.classList.contains('c-reassurance-policy-pdp__modal-overlay')) {
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      const modal = document.querySelector('.c-reassurance-policy-pdp__modal');
      if (modal && modal.getAttribute('aria-hidden') === 'false') {
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
    }
  });
})();
// V_MJA_PDP_23 | Reassurance Policy Modal

// BYOB - Auto-select product from URL param
(function () {
  var params = new URLSearchParams(window.location.search);
  var productId = params.get('product_id');
  if (!productId) return;

  function trySelect() {
    var bundleForm = document.querySelector(
      'product-bundle-form, product-combined-bundle-form'
    );
    if (!bundleForm) return false;

    // Check if click listeners are ready (render sets up selections on the component)
    if (!bundleForm.selections || bundleForm.selections.length === 0) return false;

    var targetItem = bundleForm.querySelector(
      '.bundle-selection__item[data-product-id="' + productId + '"]'
    );
    if (targetItem && !targetItem.classList.contains('actived')) {
      targetItem.click();

      // Slide Swiper to make the selected item visible
      var swiperContainer = targetItem.closest('[data-bundle-swiper]');
      if (swiperContainer && swiperContainer.swiper) {
        var slideIndex = Array.from(
          swiperContainer.querySelectorAll('.swiper-slide')
        ).indexOf(targetItem);
        if (slideIndex > -1) {
          swiperContainer.swiper.slideTo(slideIndex);
        }
      }
    }
    return true;
  }

  // Poll until the bundle form is fully rendered
  var attempts = 0;
  var interval = setInterval(function () {
    attempts++;
    if (trySelect() || attempts > 50) {
      clearInterval(interval);
    }
  }, 100);
})();

/* Inline BYOB - PDP (V_MJA_PDP_27, concluded winner — mobile only; desktop keeps control)
   Toggles between the product and an inline Build-a-Bundle builder
   (c-byob-builder) that replicates the bundle template 1:1 — same Swiper selector,
   same relative +/- option pricing, same price/Sezzle/button updates, and the same
   multi-item /cart/add.js flow with _bundle_* properties (product-bundle-form.js),
   ending in the theme cart drawer. "Build a Bundle" reveals the pre-rendered builder
   inline (no fetch, no navigation) and hides the product buy area. */
(function () {
  function money(cents) {
    if (typeof formatMoney === 'function') return formatMoney(cents);
    return '$' + (cents / 100).toFixed(2);
  }

  async function initSwipers(root) {
    /* Same loader + config as product-bundle-form.js _initSwiper()/render() */
    try {
      var utils = await import(window.theme.modules.utils);
      await utils.loadStyle(window.theme.styles.Swiper);
      await utils.loadScript(window.theme.scripts.Swiper, 'swiper');
    } catch (e) {
      return; /* Swiper failed to load; lines stay hidden like the bundle template's */
    }
    root.querySelectorAll('[data-c-byob-swiper]').forEach(function (slider) {
      new window.Swiper(slider, {
        slidesPerView: 3.1,
        simulateTouch: true,
        navigation: {
          nextEl: slider.querySelector('.swiper-button-next'),
          prevEl: slider.querySelector('.swiper-button-prev')
        },
        breakpoints: {
          640: {
            slidesPerView: 5
          }
        }
      });
    });
  }

  /* priceScope: the price block is lifted out of the builder and above the toggle (see
     initToggle), so the price nodes are looked up in the meta column, not in root. */
  function initBuilder(root, priceScope) {
    if (!root || root.dataset.cReady) return;
    root.dataset.cReady = '1';

    var scope = priceScope || root;
    var discount = parseInt(root.getAttribute('data-discount'), 10) || 0;
    var cartPopup = root.hasAttribute('data-cart-popup');
    var addLabel = root.getAttribute('data-add-label') || (window.theme && window.theme.i18n && window.theme.i18n.addToCart) || 'Add to cart';
    var priceEl = scope.querySelector('[data-c-byob-price]');
    var originalEl = scope.querySelector('[data-c-byob-original-price]');
    var sezzleEl = scope.querySelector('[data-c-byob-sezzle]');
    var addBtn = root.querySelector('[data-c-byob-add]');

    /* Sticky CTA (mobile): a proxy for addBtn, with its own copy of the price */
    var stickyEl = root.querySelector('[data-c-byob-sticky]');
    var stickyPriceEl = root.querySelector('[data-c-byob-sticky-price]');
    var stickyOriginalEl = root.querySelector('[data-c-byob-sticky-original]');
    var stickyAdd = root.querySelector('[data-c-byob-sticky-add]');

    var selections = Array.prototype.slice.call(
      root.querySelectorAll('.c-bundle-selection__line [data-c-byob-select]')
    );
    var freeSelections = Array.prototype.slice.call(
      root.querySelectorAll('.c-bundle-selection__line_free [data-c-byob-select]')
    );

    initSwipers(root);

    /* Replica of _updateSelectionPrices(): selected tile shows its price, the rest
       show the +/- difference against it (blank when equal). */
    function updateSelectionPrices(lineId) {
      var lines = root.querySelectorAll(
        lineId != null
          ? '.c-bundle-selection__line[data-bundle-id="' + lineId + '"]'
          : '.c-bundle-selection__line'
      );
      lines.forEach(function (lineWrapper) {
        var selected = lineWrapper.querySelector('.c-bundle-selection__item.c-actived');
        if (!selected) return;

        var others = lineWrapper.querySelectorAll('.c-bundle-selection__item:not(.c-actived)');
        var price = parseInt(selected.dataset.price, 10);
        var selectedPriceEl = selected.querySelector('.c-bundle-selection__product-price');
        /* The bundle templates' None tile carries no price — show blank, not "$0.00" */
        if (selectedPriceEl) selectedPriceEl.innerHTML = selected.hasAttribute('data-none') ? '' : money(price);

        others.forEach(function (item) {
          var el = item.querySelector('.c-bundle-selection__product-price');
          if (!el) return;
          var diff = parseInt(item.dataset.price, 10) - price;
          if (diff > 0) el.innerHTML = '+' + money(diff);
          else if (diff === 0) el.innerHTML = '';
          else el.innerHTML = '-' + money(-diff);
        });
      });
    }

    /* Replica of _onSelection() (no gallery swap: the inline PDP keeps its own gallery) */
    function onSelection(selection) {
      if (selection.classList.contains('c-actived')) return;
      var line = selection.closest('.c-bundle-selection__line');
      var actived = line.querySelector('.c-bundle-selection__item.c-actived');
      if (actived) actived.classList.remove('c-actived');
      selection.classList.add('c-actived');
      updateSelectionPrices(line.dataset.bundleId);
      updatePrice();
    }

    function getSelectedPrice() {
      return selections
        .filter(function (s) { return s.classList.contains('c-actived'); })
        .map(function (s) { return parseFloat(s.dataset.price) || 0; })
        .reduce(function (a, b) { return a + b; }, 0);
    }

    /* Replica of _updatePrice() + _updateButtonPrice(); no qty field on the bundle
       side, and the button reads "{label} - {discounted} {original struck through}" */
    function updatePrice() {
      var price = getSelectedPrice();
      var discountedPrice = price * ((100 - discount) / 100);

      if (priceEl) priceEl.innerHTML = money(discountedPrice);
      if (originalEl) originalEl.innerHTML = money(price);
      if (sezzleEl) sezzleEl.innerHTML = money(discountedPrice / 4);
      if (stickyPriceEl) stickyPriceEl.innerHTML = money(discountedPrice);
      if (stickyOriginalEl) stickyOriginalEl.innerHTML = money(price);

      var btnText = addBtn && addBtn.querySelector('.\\#button-text');
      if (btnText) {
        var struck = discount > 0 ? ' <s class="c-byob-add-original">' + money(price) + '</s>' : '';
        btnText.innerHTML = addLabel + ' - ' + money(discountedPrice) + struck;
      }
    }

    /* Sticky CTA shows once the real button has scrolled off the top — the same moment the
       theme raises body.form-sticky, but driven by an IntersectionObserver instead of the
       theme's scroll handler. The body class also gates the chat bubble, like form-sticky. */
    function initSticky() {
      var addWrapper = root.querySelector('.c-byob__add-wrapper');
      if (!stickyEl || !addWrapper) return;

      if (stickyAdd) {
        stickyAdd.addEventListener('click', function () {
          if (addBtn) addBtn.click();
        });
      }
      if (!('IntersectionObserver' in window)) return;
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var top = entry.rootBounds ? entry.rootBounds.top : 0;
          var passed = !entry.isIntersecting && entry.boundingClientRect.bottom <= top;
          /* Switching back to the product tab hides the builder, which fires this observer
             with a zeroed rect — the bundle-mode check stops that from re-raising the
             class right after showProduct() cleared it. */
          var inBundle = document.body.classList.contains('c-byob-bundle-active');
          document.body.classList.toggle('c-byob-sticky-active', passed && inBundle);
        });
      }).observe(addWrapper);
    }
    initSticky();

    selections.forEach(function (s) {
      s.addEventListener('click', onSelection.bind(null, s));
    });

    updateSelectionPrices();
    updatePrice();

    function setLoading(status) {
      /* The sticky CTA proxies clicks to addBtn, so it has to lock out too */
      if (stickyAdd) stickyAdd.disabled = !!status;
      if (!addBtn) return;
      status ? addBtn.setAttribute('loading', '') : addBtn.removeAttribute('loading');
    }

    /* Replica of _handleSubmit(): same _bundle_* properties, free items flagged with
       _bundle_free, one cart line per selection. */
    function handleSubmit() {
      var productUrl = root.getAttribute('data-product-url');
      var productTitle = root.getAttribute('data-product-title');
      var productImage = root.getAttribute('data-product-image');
      var qty = 1;

      var actived = selections.filter(function (s) {
        return s.classList.contains('c-actived') && !s.hasAttribute('data-none');
      });
      var freeActived = freeSelections.filter(function (s) {
        return s.classList.contains('c-actived');
      });
      if (!actived.length) return;

      var uniqueBundleId = productUrl;
      var bundleParentId = 0;
      var properties = [];

      actived.forEach(function (selection, index) {
        if (index === 0) bundleParentId = selection.dataset.variantId * 1;
        uniqueBundleId += '---' + selection.dataset.variantId;
        properties.push({
          title: selection.dataset.productTitle,
          image: selection.dataset.imageUrl,
          id: selection.dataset.variantId * 1
        });
      });

      freeActived.forEach(function (selection) {
        uniqueBundleId += '---' + selection.dataset.variantId;
        properties.push({
          title: selection.dataset.productTitle,
          image: selection.dataset.imageUrl,
          id: selection.dataset.variantId * 1
        });
      });

      var items = actived.map(function (selection) {
        return {
          quantity: qty,
          id: selection.dataset.variantId * 1,
          properties: {
            _bundle_id: uniqueBundleId,
            _bundle_parentId: bundleParentId,
            _bundle_url: productUrl,
            _bundle_title: productTitle,
            _bundle_image: productImage,
            _bundle_items: properties,
            _bundle_discount: discount
          }
        };
      });

      freeActived.forEach(function (selection) {
        items.push({
          quantity: qty,
          id: selection.dataset.variantId * 1,
          properties: {
            _bundle_id: uniqueBundleId,
            _bundle_parentId: bundleParentId,
            _bundle_url: productUrl,
            _bundle_title: productTitle,
            _bundle_image: productImage,
            _bundle_items: properties,
            _bundle_free: 'free',
            _bundle_discount: discount
          }
        });
      });

      addToCartRequest(JSON.stringify({ items: items }));
    }

    /* Replica of _addToCartRequest(): on success trigger the theme's updateCart event,
       then refresh the cart page or open the cart drawer popup. */
    function trigger(eventName, data) {
      root.dispatchEvent(new CustomEvent(eventName, {
        bubbles: true,
        composed: true,
        detail: data || {}
      }));
    }

    async function addToCartRequest(body) {
      setLoading(true);
      try {
        var response = await fetch(window.routes.cart_add_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: body
        });
        if (!response.ok) throw new Error('Failed to add items to cart');
        var data = await response.json();
        if (data.status === 422) {
          console.warn(data);
          setLoading(false);
          return;
        }
        if (!cartPopup) {
          window.location.href = window.routes.cart;
          return;
        }
        trigger('updateCart', {
          callback: function () {
            setLoading(false);
            var cartSection = document.querySelector('main-cart');
            if (cartSection && typeof cartSection.update === 'function') {
              cartSection.update();
            } else {
              trigger('openPopup', { target: 'CART' });
            }
          }
        });
      } catch (error) {
        console.error('Error adding items:', error);
        setLoading(false);
      }
    }

    if (addBtn) addBtn.addEventListener('click', handleSubmit);
  }

  function initToggle() {
    var toggle = document.querySelector('[data-c-byob-toggle]');
    if (!toggle) return;

    var inner = toggle.parentElement; // .#product-meta-inner
    var mount = inner.querySelector('[data-c-byob-mount]');
    var tabs = Array.prototype.slice.call(toggle.querySelectorAll('[data-c-byob-tab]'));
    if (!mount) return;

    /* Switching panels changes this column's height by ~280px, so everything below it — the
       description, the reviews — moves. Chrome and Firefox absorb that with native scroll
       anchoring and nothing visibly shifts; SAFARI HAS NO SCROLL ANCHORING, so there the page
       jumps ~280px on every switch. Measured at 414px with anchoring disabled: 280px of shift
       per switch without this, 0px with it. In Chrome it is a no-op (the browser has already
       corrected, so the delta reads as zero) — that is expected, not dead code.

       The same applies on first load: this all runs only once Intelligems has resolved, so the
       DOM moves below land a second or two in, by which time the visitor may already be
       scrolling.

       Note this anchors on CONTENT, not on a scrollY coordinate. Restoring an absolute
       scrollY ratchets the page down the document on every switch (measured: -328px over ten
       switches), because each one re-reads a position the browser has already clamped. */
    function preserveScroll(change) {
      var root = document.documentElement;
      var prevBehavior = root.style.scrollBehavior;

      /* Prefer the toggle — the thing just tapped shouldn't move under the finger. If it's off
         screen, anchor on the first section BELOW the product section that is on screen. What
         is deliberately NOT a candidate: `inner` and the product section, i.e. the elements
         whose height changes. Their top edge doesn't move when they resize, so anchoring there
         computes a zero delta and corrects nothing. */
      function pickAnchor() {
        var candidates = [toggle];
        var section = inner.closest('.shopify-section');
        section = section ? section.nextElementSibling : null;
        while (section) { candidates.push(section); section = section.nextElementSibling; }
        for (var i = 0; i < candidates.length; i++) {
          var el = candidates[i];
          if (!el) continue;
          var r = el.getBoundingClientRect();
          if (r.height > 0 && r.bottom > 0 && r.top < window.innerHeight) return el;
        }
        return null;
      }

      var anchor = pickAnchor();
      var beforeTop = anchor ? anchor.getBoundingClientRect().top : null;
      // Our correction must land instantly; the site sets scroll-behavior: smooth globally,
      // which would otherwise animate it and make the fix itself look like a glide.
      root.style.scrollBehavior = 'auto';

      function correct() {
        if (!anchor) return;
        var delta = anchor.getBoundingClientRect().top - beforeTop;
        if (Math.abs(delta) > 1) window.scrollBy(0, delta);
      }

      change();

      /* The height doesn't settle in one frame: the theme's sticky-ATC state lands a tick
         later, and the first time the builder is revealed its rows lay out only once Swiper
         has initialised — well after any fixed timeout. Keep correcting while the column is
         still resizing, then hand scrolling back untouched. */
      var stop = null;
      var observer = typeof ResizeObserver === 'function' ? new ResizeObserver(correct) : null;
      requestAnimationFrame(function () {
        correct();
        if (observer) observer.observe(inner);
        stop = setTimeout(function () {
          if (observer) observer.disconnect();
          clearTimeout(stop);
          root.style.scrollBehavior = prevBehavior;
        }, 1200);
      });
    }

    // Move the toggle (and its mount) to sit directly below the price block, matching the
    // design, and lift the bundle's price block ABOVE the toggle into the slot the product's
    // own price block occupies (that one is hidden in bundle mode), so the price stays put as
    // you switch tabs instead of jumping below the toggle. CSS reveals it only in bundle mode,
    // and initBuilder gets `inner` as its price scope since the nodes now live outside it.
    // Falls back to the rendered position (top of meta) if there's no price block.
    preserveScroll(function () {
      var priceBlock = null;
      Array.prototype.forEach.call(inner.children, function (el) {
        if (el.className && typeof el.className === 'string' && el.className.indexOf('@type:price') !== -1) priceBlock = el;
      });
      if (priceBlock) {
        priceBlock.insertAdjacentElement('afterend', toggle);
        toggle.insertAdjacentElement('afterend', mount);
      }
      var bundlePrice = mount.querySelector('.c-byob__price');
      if (bundlePrice) toggle.insertAdjacentElement('beforebegin', bundlePrice);
    });

    // Buy-area blocks replaced by the builder (the builder brings its own price, qty and
    // ATC, like the bundle template's meta column). In bundle mode the product's own
    // price block is hidden too. Title, rating and the rest of the meta stay visible.
    var HIDE_TYPES = ['price', 'variant_picker', 'quantity_selector', 'addons', 'c_addons_var_a', 'buy_buttons'];
    var hiddenEls = [];
    function hideBuyArea() {
      Array.prototype.forEach.call(inner.children, function (el) {
        if (!el.className || typeof el.className !== 'string') return;
        for (var i = 0; i < HIDE_TYPES.length; i++) {
          if (el.className.indexOf('@type:' + HIDE_TYPES[i]) !== -1) { el.style.display = 'none'; hiddenEls.push(el); break; }
        }
      });
    }
    function restoreBuyArea() {
      hiddenEls.forEach(function (el) { el.style.display = ''; });
      hiddenEls = [];
    }

    function setActive(which) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-c-byob-tab') === which;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    /* The theme only recomputes body.form-sticky inside its own scroll handler
       (product-form.js) — it never reconsiders it otherwise. Toggling hides and restores the
       product form underneath that class without any scrolling, so the class is left stale and
       the sticky add-to-cart bar doesn't come back on the product tab. In Chrome it happens to
       recover, because native scroll anchoring shifts scrollY and that fires a scroll event;
       Safari has no anchoring, so nothing fires and the class never updates. Dispatching a
       scroll event makes the theme recompute from the current layout. */
    function syncThemeSticky() {
      document.dispatchEvent(new Event('scroll'));
    }

    function showBundle() {
      preserveScroll(function () {
        setActive('bundle');
        inner.classList.add('c-byob-bundle-active');
        document.body.classList.add('c-byob-bundle-active');
        mount.removeAttribute('hidden');
        hideBuyArea();
        syncThemeSticky();
      });
      initBuilder(mount.querySelector('[data-c-byob]'), inner);
    }
    function showProduct() {
      preserveScroll(function () {
        setActive('product');
        inner.classList.remove('c-byob-bundle-active');
        document.body.classList.remove('c-byob-bundle-active');
        /* Drop the sticky state with it — it also gates the chat bubble */
        document.body.classList.remove('c-byob-sticky-active');
        restoreBuyArea();
        syncThemeSticky();
      });
    }

    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        if (t.getAttribute('data-c-byob-tab') === 'bundle') showBundle();
        else showProduct();
      });
    });

    // Deep-link support: if linked back with ?bundle=1, open the builder.
    try {
      if (new URLSearchParams(window.location.search).get('bundle') === '1') showBundle();
    } catch (e) {}

    /* Exposed so the mobile-only gate below can hand the column back to the product view if
       the viewport crosses up to desktop while the builder is open. */
    return { showProduct: showProduct };
  }

  /* Re-assert body.form-sticky on mobile while scrolling down, on the PDPs that carry the Loox
     reviews widget (#looxReviews). The theme only ever sets that class from its own scroll
     handler, so a tab switch can leave it off and the sticky add-to-cart bar never returns.
     syncThemeSticky() covers the switch itself; this covers everything after it.

     Gated on the reviews widget having been reached rather than merely existing: adding the
     class while the real buy area is still on screen would show the sticky bar on top of the
     live add-to-cart button. By the reviews the buy area is long gone, so it's safe.

     Removal is deliberately left to the theme — it drops the class again when the buy area
     comes back into view near the top, and this only re-adds on the way down. */
  function initStickyOnScroll() {
    var reviews = document.getElementById('looxReviews');
    if (!reviews) return;

    // Same breakpoint as the theme's sticky-bar CSS (custom.css: max-width 991px)
    var mobile = window.matchMedia(MOBILE_QUERY);
    var lastY = window.pageYOffset;

    window.addEventListener('scroll', function () {
      var y = window.pageYOffset;
      var scrollingDown = y > lastY;
      lastY = y;
      if (!scrollingDown || !mobile.matches) return;
      // Only once the reviews widget has come into view
      if (reviews.getBoundingClientRect().top > window.innerHeight) return;
      document.body.classList.add('form-sticky');
    }, { passive: true });
  }

  /* Rollout scope: MOBILE ONLY — desktop keeps the control (the byob banner and the theme's
     own buy area), so the toggle is never initialised there. initToggle() moves nodes around
     the meta column and can hide the buy area, none of which should touch a desktop page.

     Same breakpoint as the CSS that hides the toggle above it and as the theme's own sticky
     add-to-cart bar (custom.css: max-width 991px).

     Init is deferred rather than skipped when the page loads wide: a resize or an orientation
     change down into mobile starts it then, and once started it stays started, because the
     node moves it performs are not worth undoing. Crossing back up to desktop only needs the
     column returned to the product view — CSS hides the toggle again on its own. */
  var MOBILE_QUERY = '(max-width: 991px)';

  function init() {
    var mobile = window.matchMedia(MOBILE_QUERY);
    var toggleApi = null;
    var started = false;

    function start() {
      if (started || !mobile.matches) return;
      started = true;
      toggleApi = initToggle();
      initStickyOnScroll();
    }

    function onBreakpointChange() {
      if (mobile.matches) {
        start();
      } else if (toggleApi && document.body.classList.contains('c-byob-bundle-active')) {
        // Widened while the builder was open: restore the buy area so desktop is left in
        // exactly the state the control renders.
        toggleApi.showProduct();
      }
    }

    start();
    if (typeof mobile.addEventListener === 'function') {
      mobile.addEventListener('change', onBreakpointChange);
    } else if (typeof mobile.addListener === 'function') {
      mobile.addListener(onBreakpointChange); // Safari < 14
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* ============================================================================================
   V_MJA_PDP_37 | Upsell - Pop Up - PDP

   Adding to cart from the PDP hands the shopper an upsell pop up instead of the cart drawer.
   The drawer is not suppressed - it is deferred: the pop up's cart button opens it, and
   "continue shopping" closes the pop up and leaves the shopper on the product page.

   CONCLUDED WINNER: Var B - curated generic accessories. Every shopper now gets it; the
   Intelligems split and Var A's product-specific rows have been removed.

   The rows are the curated cart add-ons, read straight off the cart drawer's own markup
   (.cart-addon-card). Those rows are rendered by sections/main-cart.liquid and their
   eligibility depends on what is in the cart, so reading the drawer keeps that logic in one
   place - and by the time the pop up opens the drawer has already re-rendered with the
   product that was just added.

   The "AB Test: Enable the add-to-cart upsell pop up" theme setting is still the master
   switch: with it off the pop up markup is never rendered and add to cart opens the drawer,
   exactly as it did before the test.

   The rows are built as .product_addons--item, the PDP add-on component styled by
   assets/product-meta.css, so the pop up reuses the rows the shopper already sees below the buy
   box instead of introducing a second look for the same thing.

   The hand-off works by catching the theme's own `openPopup` event on its way to modal.js.
   product-form.js fires it (target: CART) from inside the callback of the cart update it just
   made, so at that moment the add has succeeded AND the drawer markup is current. A
   capture-phase listener on document sees the event before modal.js's bubble-phase one and stops
   it there. Only the event that follows the PDP's own buy form is caught: an add-on added
   straight from the page below the buy box still opens the drawer, exactly like control. And if
   there is nothing to upsell, the event is left alone - the drawer opens as usual rather than
   showing an empty pop up.

   The pop up's copy comes from the "AB Test - V_MJA_PDP_37" theme settings. The values below are
   not settings on purpose: they are the add button's own states and two safety timeouts, and they
   deliberately match the strings and timings the PDP add-ons and the cart add-ons already use.
   ============================================================================================ */
(function () {
  'use strict';

  /* Concluded winner: Var B - curated generic accessories. The Intelligems split is
     gone, so every shopper takes the Var B path. Kept as a function rather than
     inlined so the guards below still read the same. */

  // The add button's states, matching snippets/product-meta.liquid and the cart add-ons above.
  var LABEL_ADD = 'ADD +';
  var LABEL_ADDING = 'ADDING...';
  var LABEL_ADDED = 'ADDED';
  var LABEL_ERROR = 'ERROR';

  // How long a failed add stays on screen before the button offers itself again - same as the
  // cart add-ons.
  var ERROR_RESET_MS = 2000;
  // How long after add to cart the pop up may replace the drawer. If Shopify takes longer than
  // this the drawer opens as normal, so a slow response can never leave the shopper with nothing.
  var ATC_WINDOW_MS = 15000;

  // Absent on every page but the PDP, and absent everywhere when the customizer switch is off.
  var root = document.querySelector('[data-c-pdp37]');
  if (!root) return;

  // Liquid renders the pop up inside the product section, and that section can carry a reveal
  // transform - which would turn `position: fixed` into `position: absolute` and leave the
  // overlay covering only part of the page. Hoisting it to the body once, up front, is what
  // keeps it pinned to the viewport.
  if (root.parentNode !== document.body) document.body.appendChild(root);

  var configEl = root.querySelector('[data-c-pdp37-config]');
  var config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (e) {
    console.warn('V_MJA_PDP_37: pop up config is invalid - falling back to the cart drawer.', e);
    return;
  }

  var $dialog = root.querySelector('.c-pdp37__dialog');
  var $list = root.querySelector('[data-c-pdp37-list]');
  var $addedTitle = root.querySelector('[data-c-pdp37-added-title]');
  var $addedPrice = root.querySelector('[data-c-pdp37-added-price]');
  var $cta = root.querySelector('[data-c-pdp37-gotocart]');

  function activeVariant() {
    return 'b';
  }

  function text(el) {
    return el ? (el.textContent || '').trim() : '';
  }

  /* -- the cart drawer ---------------------------------------------------------------------- */

  function cartModal() {
    return document.querySelector('modal-popup[enable-cart]');
  }

  // modal.js fetches the cart section once and keeps it as modal.cartContent - a detached
  // <main-cart> while the drawer is shut, which main-cart.update() re-renders on every cart
  // change. The Var B add-ons are read from it, so the pop up costs no extra request.
  function cartContent() {
    var modal = cartModal();
    return modal && modal.cartContent ? modal.cartContent : null;
  }

  // Keeps the counter and the drawer in step after one of our adds. The drawer listens for
  // this to re-render itself; it never opens on its own.
  function refreshCart() {
    document.dispatchEvent(new CustomEvent('updateCart', {
      bubbles: true,
      composed: true,
      detail: { callback: function () {} }
    }));
  }

  /* -- money ---------------------------------------------------------------------------------
     The drawer's variant <select> carries prices in cents. Formatting follows the storefront's
     own active currency rather than a currency baked in here. */
  function formatMoney(cents, fallback) {
    var amount = parseInt(cents, 10);
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || null;
    if (isNaN(amount) || !currency) return fallback || '';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(amount / 100);
    } catch (e) {
      return fallback || '';
    }
  }

  /* -- open / close --------------------------------------------------------------------------- */

  var isOpen = false;
  // Raised only while WE ask the drawer to open, so the guard below lets that one through.
  var openingDrawer = false;
  var hideTimer = null;
  var lastFocus = null;

  // How long the dialog takes to fade is a design decision, so it lives in the stylesheet and is
  // read back from there - the markup must not be re-hidden before the transition has finished.
  function transitionMs(el) {
    var value = parseFloat(window.getComputedStyle(el).transitionDuration || '0');
    return isNaN(value) ? 0 : value * 1000;
  }

  function onKeydown(e) {
    if (e.key === 'Escape' || e.key === 'Esc') closePopup();
  }

  function openPopup() {
    if (isOpen) return;
    isOpen = true;
    clearTimeout(hideTimer);
    lastFocus = document.activeElement;
    root.removeAttribute('hidden');
    // Two frames: the first commits the un-hidden layout, the second starts the transition.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { root.classList.add('c-pdp37--open'); });
    });
    document.documentElement.classList.add('overflow-hidden');
    document.addEventListener('keydown', onKeydown);
    if ($cta) $cta.focus({ preventScroll: true });
  }

  function closePopup() {
    if (!isOpen) return;
    isOpen = false;
    root.classList.remove('c-pdp37--open');
    document.documentElement.classList.remove('overflow-hidden');
    document.removeEventListener('keydown', onKeydown);
    hideTimer = setTimeout(function () {
      if (!isOpen) root.setAttribute('hidden', '');
    }, transitionMs($dialog));
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus({ preventScroll: true });
  }

  /* -- the confirmation line ------------------------------------------------------------------ */

  function setAdded(title, price) {
    if ($addedTitle) $addedTitle.textContent = title || '';
    if ($addedPrice) $addedPrice.textContent = price || '';
  }

  /* -- rows ----------------------------------------------------------------------------------- */

  // ADDED is the feedback for a press inside this pop up, nothing more. It lasts as long as
  // the pop up is open and is gone the next time the rows are built, so a shopper who goes
  // through the flow again - or reloads and adds the product again - can add the same add-on
  // again rather than meeting a dead button.
  function markAdded(item, button) {
    button.disabled = true;
    button.classList.add('c-pdp37__add--added');
    button.textContent = LABEL_ADDED;
    var select = item ? item.querySelector('.c-pdp37__variant-select') : null;
    if (select) select.disabled = true;
  }

  /* -- the Var B card registry -----------------------------------------------------------------
     sections/main-cart.liquid only renders a curated add-on card while that product is NOT in
     the cart, so a card disappears the moment a shopper takes the offer. The pop up has to keep
     offering every add-on on every pass, so each card the drawer has shown is remembered for the
     session and merged back in behind whatever the drawer is rendering right now. Nothing here
     touches the drawer itself - control still gets the theme's own behaviour. */
  var VARB_CARDS_KEY = 'c_pdp37_varb_cards';
  var VARB_CARDS_MAX = 12;

  // Keyed by product, not variant: a re-render that defaults the card to a different size must
  // update the remembered card rather than sit beside it as a second row.
  function cardKey(card) {
    var select = card.querySelector('.cart-addon-variant-select');
    if (select && select.dataset.productId) return 'p' + select.dataset.productId;
    var btn = card.querySelector('.cart-addon-btn');
    return btn && btn.dataset.variantId ? 'v' + btn.dataset.variantId : '';
  }

  function readRememberedCards() {
    try {
      var list = JSON.parse(window.sessionStorage.getItem(VARB_CARDS_KEY) || '[]');
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function writeRememberedCards(list) {
    try {
      window.sessionStorage.setItem(VARB_CARDS_KEY, JSON.stringify(list.slice(0, VARB_CARDS_MAX)));
    } catch (e) { /* storage blocked - the pop up still works, it just forgets between loads */ }
  }

  function drawerCards() {
    var content = cartContent();
    if (!content) return [];
    return Array.prototype.slice.call(content.querySelectorAll('.cart-addons-section .cart-addon-card'));
  }

  // The drawer's markup always wins for a card it is still rendering - its price, its default
  // variant - but the ORDER is whatever the shopper saw first: a row must not jump down the list
  // just because its product went into the cart. Cards the drawer has never shown are appended.
  function mergeCards(cards) {
    var fresh = {};
    cards.forEach(function (card) {
      var key = cardKey(card);
      if (key) fresh[key] = card.outerHTML;
    });

    var merged = [];
    var placed = {};

    readRememberedCards().forEach(function (entry) {
      if (!entry || !entry.key || !entry.html || placed[entry.key]) return;
      placed[entry.key] = true;
      merged.push({ key: entry.key, html: fresh[entry.key] || entry.html });
    });

    Object.keys(fresh).forEach(function (key) {
      if (placed[key]) return;
      placed[key] = true;
      merged.push({ key: key, html: fresh[key] });
    });

    writeRememberedCards(merged);
    return merged;
  }

  // Remember what the drawer is showing while it still shows it - by the time the pop up opens,
  // the add that triggered it has already re-rendered the drawer.
  function rememberDrawerCards() {
    if (activeVariant() !== 'b') return;
    var cards = drawerCards();
    if (cards.length) mergeCards(cards);
  }

  function cardFromHTML(html) {
    var host = document.createElement('div');
    host.innerHTML = html;
    return host.firstElementChild;
  }

  // Var B: the drawer's curated add-on cards, rebuilt as PDP add-on rows.
  function rowsForVarB() {
    return mergeCards(drawerCards())
      .map(function (entry) {
        var card = cardFromHTML(entry.html);
        return card ? rowFromCard(card) : null;
      })
      .filter(Boolean);
  }

  function rowFromCard(card) {
    var sourceBtn = card.querySelector('.cart-addon-btn');
    if (!sourceBtn || !sourceBtn.dataset.variantId) return null;

    var item = document.createElement('li');
    item.className = 'product_addons--item';
    item.setAttribute('data-c-pdp37-item', '');
    item.setAttribute('data-variant-id', sourceBtn.dataset.variantId);

    var imageLink = document.createElement('a');
    imageLink.className = 'item-image-link';
    var sourceImg = card.querySelector('.cart-addon-image img');
    if (sourceImg) {
      var img = document.createElement('img');
      img.className = 'product_addons--image';
      img.src = sourceImg.getAttribute('src') || '';
      img.alt = sourceImg.getAttribute('alt') || '';
      img.width = 65;
      img.height = 65;
      img.loading = 'lazy';
      imageLink.appendChild(img);
    }

    var meta = document.createElement('a');
    meta.className = 'item-meta';

    var title = document.createElement('p');
    title.className = 'item-title';
    title.textContent = text(card.querySelector('.cart-addon-name'));
    meta.appendChild(title);

    // The drawer's own variant picker comes across as-is, so the pop up offers exactly the sizes
    // and styles the drawer does. Its class is dropped on the way: the drawer's delegated change
    // handler looks for a .cart-addon-card ancestor this copy does not have.
    var sourceSelect = card.querySelector('.cart-addon-variant-select');
    var plainVariant = card.querySelector('.cart-addon-variant');

    var price = document.createElement('p');
    price.className = 'item-price';
    price.setAttribute('data-c-pdp37-price', '');
    price.textContent = text(card.querySelector('.cart-addon-price'));

    // A picker is a control, so it goes last - under the price - where it reads as something to
    // act on. A plain variant name is just part of the product's name and stays above the price,
    // which is where Var A's rows put it too.
    if (sourceSelect) {
      var select = sourceSelect.cloneNode(true);
      select.classList.remove('cart-addon-variant-select');
      select.classList.add('c-pdp37__variant-select');
      meta.appendChild(price);
      meta.appendChild(select);
    } else {
      if (plainVariant) {
        var variantLine = document.createElement('p');
        variantLine.className = 'item-variant-title';
        variantLine.textContent = text(plainVariant);
        meta.appendChild(variantLine);
      }
      meta.appendChild(price);
    }

    var button = document.createElement('button');
    button.type = 'button';
    button.setAttribute('data-c-pdp37-add', '');
    button.setAttribute('data-variant-id', sourceBtn.dataset.variantId);
    button.textContent = LABEL_ADD;

    item.appendChild(imageLink);
    item.appendChild(meta);
    item.appendChild(button);
    return item;
  }

  // Every open starts from a clean list: nothing is pre-marked from what the cart already
  // holds, so an add-on the shopper bought earlier is offered again on the next pass.
  function buildRows() {
    return rowsForVarB();
  }

  /* -- adding from inside the pop up ---------------------------------------------------------- */

  function addFromPopup(button) {
    var item = button.closest('[data-c-pdp37-item]');
    var variantId = parseInt(button.dataset.variantId, 10);
    if (!item || !variantId || button.disabled || !window.routes || !window.routes.cart_add_url) return;

    button.disabled = true;
    button.classList.add('c-pdp37__add--busy');
    button.textContent = LABEL_ADDING;

    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok || data.status === 422) throw new Error(data.description || res.status);
          return data;
        });
      })
      .then(function () {
        button.classList.remove('c-pdp37__add--busy');
        markAdded(item, button);
        // The confirmation line follows the most recent add, so the shopper can see what the
        // press did without the pop up closing or the drawer taking over.
        setAdded(text(item.querySelector('.item-title')), text(item.querySelector('.item-price')));
        refreshCart();
      })
      .catch(function (err) {
        console.warn('V_MJA_PDP_37: add-on could not be added.', err);
        button.classList.remove('c-pdp37__add--busy');
        button.disabled = false;
        button.textContent = LABEL_ERROR;
        setTimeout(function () {
          if (!button.classList.contains('c-pdp37__add--added')) button.textContent = LABEL_ADD;
        }, ERROR_RESET_MS);
      });
  }

  // Picking a different size/style re-points the add button and re-prices the row, matching the
  // drawer's own behaviour for the same <select>.
  function onVariantChange(e) {
    var select = e.target.closest ? e.target.closest('.c-pdp37__variant-select') : null;
    if (!select) return;

    var option = select.options[select.selectedIndex];
    var item = select.closest('[data-c-pdp37-item]');
    if (!option || !item) return;

    var button = item.querySelector('[data-c-pdp37-add]');
    var price = item.querySelector('[data-c-pdp37-price]');
    var img = item.querySelector('.product_addons--image');

    if (button) button.setAttribute('data-variant-id', option.value);
    item.setAttribute('data-variant-id', option.value);
    if (price) price.textContent = formatMoney(option.dataset.price, price.textContent);
    if (img && option.dataset.image) {
      img.src = option.dataset.image;
      img.alt = (option.textContent || '').trim();
    }
  }

  /* -- catching the drawer ---------------------------------------------------------------------
     A pressed buy form is remembered so only the `openPopup` that belongs to it is intercepted. */

  var atcPressedAt = 0;
  var atcVariantId = null;

  document.addEventListener('submit', function (e) {
    if (!activeVariant()) return;
    var form = e.target;
    if (!form || typeof form.matches !== 'function') return;
    if (!form.matches('form[data-type="add-to-cart-form"]')) return;

    // The PDP's own buy form only - a quick-add form inside a modal keeps control's behaviour.
    var productForm = form.closest('product-form');
    if (!productForm || productForm.getAttribute('page-type') !== 'product') return;

    atcPressedAt = Date.now();
    var input = form.querySelector('[data-variant-id-input]');
    atcVariantId = (input && input.value) || productForm.getAttribute('current-variant');
  }, true);

  document.addEventListener('openPopup', function (e) {
    if (!activeVariant()) return;
    if (openingDrawer) return;
    if (!e.detail || e.detail.target !== 'CART') return;
    if (!atcPressedAt || Date.now() - atcPressedAt > ATC_WINDOW_MS) return;

    atcPressedAt = 0;

    // Nothing left to offer - leave the event alone and let the drawer open, as control does.
    var rows = buildRows();
    if (!rows.length) return;

    // Caught at document in the capture phase, so modal.js's bubble-phase listener - and with it
    // the drawer - never sees it.
    e.stopPropagation();

    var variantData = (config.variants || {})[String(atcVariantId)] || null;
    setAdded(variantData ? variantData.title : '', variantData ? variantData.price : '');

    $list.replaceChildren();
    rows.forEach(function (item) { $list.appendChild(item); });

    openPopup();
  }, true);

  /* -- the pop up's own controls ---------------------------------------------------------------- */

  root.addEventListener('click', function (e) {
    var add = e.target.closest('[data-c-pdp37-add]');
    if (add) {
      e.preventDefault();
      addFromPopup(add);
      return;
    }
    if (e.target.closest('[data-c-pdp37-close]') ||
        e.target.closest('[data-c-pdp37-continue]') ||
        e.target.closest('[data-c-pdp37-overlay]')) {
      e.preventDefault();
      closePopup();
    }
  });

  root.addEventListener('change', onVariantChange);

  // Every cart change re-renders the drawer, which is the only moment a card that is about to
  // drop out (its product just went into the cart) can still be captured. ig:ready is in here
  // too because the body class this checks is set by Intelligems, which may land after this
  // script does - and each of these is a no-op outside Var B.
  document.addEventListener('updateCart', rememberDrawerCards);
  window.addEventListener('ig:ready', rememberDrawerCards);
  rememberDrawerCards();

  if ($cta) {
    $cta.addEventListener('click', function (e) {
      // With the drawer switched off in the customizer the button is a plain link to /cart.
      if (!cartModal()) return;
      e.preventDefault();
      closePopup();
      openingDrawer = true;
      document.dispatchEvent(new CustomEvent('openPopup', {
        bubbles: true,
        composed: true,
        detail: { target: 'CART' }
      }));
      openingDrawer = false;
    });
  }
})();
